import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "./Motion";

export const CtaBand = ({ title, to, label, testId }) => (
  <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <FadeUp className="flex flex-col items-start justify-between gap-10 border-t border-[#D6CEBF] pt-14 lg:flex-row lg:items-end">
      <h2 className="max-w-3xl font-serif text-4xl leading-[1.05] tracking-tight text-[#1C1917] sm:text-6xl">{title}</h2>
      <Link
        to={to}
        data-testid={testId}
        className="group inline-flex shrink-0 items-center gap-4 rounded-full bg-[#1C1917] py-4 pl-7 pr-4 text-sm font-medium text-[#FBF9F5] transition-colors duration-300 hover:bg-[#C85A32]"
      >
        {label}
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#FBF9F5] text-[#1C1917] transition-transform duration-500 group-hover:rotate-[-45deg]">
          <ArrowRight size={16} />
        </span>
      </Link>
    </FadeUp>
  </section>
);
